import React from 'react';
import SelectComponent from 'shared/components/SelectComponent';

const StencilWidthSelect = (props) => {
  const name = 'stencil_width';

  const {
    label,
    onChangeParameter,
    parameters,
    required,
    options,
    tooltip,
    groupName,
    errorMessage,
  } = props;

  return (
    <SelectComponent
      label={label}
      name={name}
      onChange={(e) => onChangeParameter(name, e.target.value)}
      required={required}
      options={options}
      tooltip={tooltip}
      selected={parameters[name] || ''}
      groupName={groupName}
      errorMessage={errorMessage} />
  );
};

StencilWidthSelect.defaultProps = {
  options: [],
  label: Spree.translations.parameters.stencil_width,
  tooltip: Spree.helpForParameters.stencil_width,
};

export default StencilWidthSelect;
